var exports = {
  "Mv": "TextareaButtons.module__invisibleTrigger___WFN5U3",
  "IO": "TextareaButtons.module__mobileRightButtonContainer___WFN5U3",
  "Pc": "TextareaButtons.module__mobileRightButtonSlot___WFN5U3",
};

module.exports = exports;
